import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const PARENT_GAP_OFFSET_CLASS = '-mt-page-gap';

interface FilterPanelCollapseProps {
  isOpen: boolean;
  children: ReactNode;
}

export function FilterPanelCollapse({ isOpen, children }: FilterPanelCollapseProps) {
  return (
    <div
      inert={!isOpen}
      className={cn(
        'grid transition-[grid-template-rows,margin-top,opacity] duration-300 ease-out motion-reduce:transition-none',
        isOpen
          ? 'grid-rows-[1fr] opacity-100'
          : cn('grid-rows-[0fr] opacity-0', PARENT_GAP_OFFSET_CLASS),
      )}
    >
      <div className="min-h-0 overflow-hidden">{children}</div>
    </div>
  );
}
